import { isNotNil } from '@wistia/type-guards';

export const getControlProps = (
  isOpen: boolean | undefined,
  onOpenChange: ((next: boolean) => void) | undefined,
) => {
  return isNotNil(onOpenChange) && isNotNil(isOpen) ? { open: isOpen, onOpenChange } : {};
};
